import styled, { useTheme } from "styled-components/native";
import React from "react";

import { PriceDetailViewProps } from "./types";
import { VDBText } from "@components/atoms";
import { useTypographyStore } from "@redux/slices/typographySlice";
import JBTDetail from "../JBTDetail";
import { useTranslation } from "react-i18next";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";

const SupplierDetail = ({ itemDetail }: PriceDetailViewProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const { t } = useTranslation();
  const { isJbtDisabled } = useOrgSettingsSlice();
  return (
    <ContainerView>
      <LabelTextContainer>
        <VDBText
          type={typography["Body-R"]}
          color={theme["core-06"]}
          selectable={true}
        >
          {t("productDetail.supplierDetail.supplier.text", "Supplier")}
        </VDBText>
      </LabelTextContainer>

      <LabelTextContainer>
        <VDBText
          type={typography["Large-B"]}
          color={theme["core-05"]}
          selectable={true}
        >
          {itemDetail?.vendor_name}
        </VDBText>
      </LabelTextContainer>

      {!isJbtDisabled && itemDetail?.jbt_detail && (
        <JBTDetail
          logoUrl={itemDetail?.jbt_detail?.icon_url}
          member_type={itemDetail?.jbt_detail?.member_type}
          info_text={itemDetail?.jbt_detail?.info_text}
          vendor_name={itemDetail?.vendor_name}
          mItem={itemDetail}
          jbtDetail={itemDetail.jbt_detail}
          screenName={"detail_page"}
        />
      )}
    </ContainerView>
  );
};

const ContainerView = styled.View`
  padding-top: 4px;
`;

const LabelTextContainer = styled.View`
  margin-bottom: 4px;
`;

export default SupplierDetail;
